export enum BoosterType {
  Hammer = 'Hammer',
  Move = 'Move',
  Redraw = 'Redraw',
  Undo = 'Undo',
}

export type BoosterTypeMap<T> = Record<BoosterType, T>;

export interface BoosterDefinition {
  type: BoosterType;
  unlockLevel: number;
  coinCost: number;
  name: string;
  description: string;
}

export type BoosterDefinitions = BoosterTypeMap<BoosterDefinition>;
